import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import { useGrades } from '../grades/Grades';
import { useSeries } from '../series/Series';

const useStyles = makeStyles((theme) => ({
  input: {
    width: '50%',
    marginTop: '20px',
  },
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
    width: '80%',
  },
}));

function useForm() {
  const [entries, setEntries] = useState({});

  const handleChange = (event) => {
    const { name, value } = event.target;
    setEntries({
      ...entries,
      [name]: value,
    });
  };

  return {
    entries,
    handleChange,
  };
}

const assocTypes = {
  evaluation: 'Evaluación',
  workshop: 'Taller',
  open: 'Abierta',
};

function useQuestions() {
  const [questions, setQuestions] = useState([]);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    fetch(
      `https://api.edicionesmilenio.com/api/questions/filter?page=${page}&limit=${limit}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          isContextual: false,
        }),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        let q = data?.data?.docs.map((question) => {
          return {
            id: question?._id,
            title: question?.title,
            question: question?.question,
            questionType: assocTypes[question?.questionType],
            grade: question?.grade?.name,
            serie: question?.serie?.name,
            period: question?.period,
            activityType: question?.activityType,
          };
        });

        setQuestions({ ...data?.data, docs: q });
      });
  }, [limit, page]);

  return {
    limit,
    page,
    questions,
    setLimit,
    setPage,
  };
}

function useContextQuestions() {
  const [contexts, setContexts] = useState([]);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    fetch(
      `https://api.edicionesmilenio.com/api/contextquestions?page=${page}&limit=${limit}`
    )
      .then((res) => res.json())
      .then((data) => {
        let c = data?.data?.docs?.map((context) => {
          return {
            id: context?._id,
            title: context?.title,
            description: context?.description,
            activityType: context?.activityType,
            grade: context?.grade?.name,
            serie: context?.serie?.name,
            period: context?.period,
            questions: context?.questions?.length,
          };
        });

        setContexts({ ...data?.data, docs: c });
      });
  }, [limit, page]);

  return {
    contexts,
    limit,
    page,
    setLimit,
    setPage,
  };
}

const questionColumns = [
  {
    name: 'question',
    label: 'Pregunta',
    options: {
      filter: false,
    },
  },
  {
    name: 'questionType',
    label: 'Tipo de pregunta',
  },
  {
    name: 'grade',
    label: 'Grado',
  },
  {
    name: 'serie',
    label: 'Serie',
  },
  {
    name: 'period',
    label: 'Periodo',
  },
  {
    name: 'activityType',
    label: 'Tipo de actividad',
  },
];

const contextColumns = [
  {
    name: 'title',
    label: 'Título',
    options: {
      filter: false,
    },
  },
  {
    name: 'questions',
    label: 'Preguntas',
  },
  {
    name: 'activityType',
    label: 'Tipo de actividad',
  },
  {
    name: 'grade',
    label: 'Grado',
  },
  {
    name: 'serie',
    label: 'Serie',
  },
  {
    name: 'period',
    label: 'Periodo',
  },
];

export function CreateWorkShop() {
  const { entries, handleChange } = useForm();
  const { series } = useSeries();
  const { grades } = useGrades();
  const {
    limit: limitQuestions,
    page: pageQuestions,
    questions,
    setLimit: setLimitQuestions,
    setPage: setPageQuestions,
  } = useQuestions();
  const {
    contexts,
    limit: limitContexts,
    page: pageContexts,
    setLimit: setLimitContexts,
    setPage: setPageContexts,
  } = useContextQuestions();
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [selectedContexts, setSelectedContexts] = useState([]);
  const classes = useStyles();
  const navigate = useNavigate();

  const activityTypes = useMemo(
    () => [
      'Prueba diagnóstica',
      'Evaluación de periodo',
      'Taller evaluativo 1',
      'Taller evaluativo 2',
      'Taller evaluetivo 3',
      'Taller evaluativo 4',
      'Taller evaluativo 5',
      'Taller de práctica 1',
      'Taller de práctica 2',
      'Taller de práctica 3',
      'Taller de práctica 4',
      'Taller de práctica 5',
    ],
    []
  );

  function handleCreate() {
    const data = {
      ...entries,
      title: entries?.evaluationType,
      questions: [...selectedContexts, ...selectedQuestions],
      time: entries?.time * 60 * 1000,
    };

    fetch('https://api.edicionesmilenio.com/api/evaluations', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        navigate('/admin/workshops');
      })
      .catch((err) => {
        window.alert('Error al crear la actividad, intente de nuevo');
      });
  }

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <p className={classes.formSpan}>
        Estimado administrador, desde esta sección podrás crear una nueva
        actividad para cada serie, libro, grado y periodo en la plataforma,
        recuerda completar todos los campos para que el proceso sea más
        completo. Al finalizar deberás asociar las preguntas que pertenecen a la
        actividad, ya sean de preguntas contextuales o de preguntas estándar,
        usa los filtros para seleccionar las preguntas correctas.
      </p>
      <TextField
        name="title"
        label="Título"
        variant="outlined"
        value={entries?.evaluationType || ''}
        onChange={handleChange}
        className={classes.input}
        disabled
      />
      <TextField
        name="description"
        label="Descripción"
        variant="outlined"
        value={entries?.description}
        onChange={handleChange}
        className={classes.input}
        multiline
        minRows={4}
      />

      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="activitytype-label">Tipo de actividad</InputLabel>
        <Select
          labelId="activitytype-label"
          id="activitytype"
          name="evaluationType"
          value={entries?.evaluationType}
          onChange={handleChange}
          label="Tipo de actividad"
        >
          {activityTypes.map((activityType) => (
            <MenuItem value={activityType}>{activityType}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="series-label">Serie</InputLabel>
        <Select
          labelId="series-label"
          id="series"
          name="serie"
          value={entries?.serie}
          onChange={handleChange}
          label="Serie"
        >
          {series.map((serie) => (
            <MenuItem value={serie?._id}>{serie?.name}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="grade-label">Grado</InputLabel>
        <Select
          labelId="grade-label"
          id="grade"
          name="grade"
          value={entries?.grade}
          onChange={handleChange}
          label="Grado"
        >
          {grades.map((grade) => (
            <MenuItem value={grade?._id}>{grade?.name}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="period-label">Periodo</InputLabel>
        <Select
          labelId="period-label"
          id="period"
          name="period"
          value={entries?.period}
          onChange={handleChange}
          label="Periodo"
        >
          <MenuItem value="1">1</MenuItem>
          <MenuItem value="2">2</MenuItem>
          <MenuItem value="3">3</MenuItem>
          <MenuItem value="4">4</MenuItem>
        </Select>
      </FormControl>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-around',
          alignItems: 'flex-start',
          width: '98%',
          marginTop: '30px',
          padding: '20px',
        }}
      >
        <div style={{ width: '100%' }}>
          <p style={{ marginBottom: '20px', color: '#777' }}>
            Seleccione los contextos de la actividad
          </p>
          <MUIDataTable
            title={'Contextos'}
            data={contexts?.docs || []}
            columns={contextColumns}
            options={{
              serverSide: true,
              count: questions?.totalDocs || 0,
              page: pageContexts,
              rowsPerPage: limitContexts,
              selectableRows: 'multiple',
              filterType: 'dropdown',
              responsive: 'scrollMaxHeight',
              search: false,
              delete: false,
              download: false,
              print: false,
              viewColumns: false,
              textLabels: {
                body: {
                  noMatch:
                    'Lo sentimos, no se encontraron registros coincidentes',
                  toolTip: 'Ordenar',
                  columnHeaderTooltip: (column) =>
                    `Ordenar por ${column.label}`,
                },
                pagination: {
                  next: 'Siguiente',
                  previous: 'Anterior',
                  rowsPerPage: 'Filas por página:',
                  displayRows: 'de',
                },
                toolbar: {
                  search: 'Buscar',
                  downloadCsv: 'Descargar CSV',
                  print: 'Imprimir',
                  viewColumns: 'Ver columnas',
                  filterTable: 'Filtrar tabla',
                },
                filter: {
                  all: 'Todos',
                  title: 'FILTROS',
                  reset: 'REINICIAR',
                },
                viewColumns: {
                  title: 'Mostrar columnas',
                  titleAria: 'Mostrar/Ocultar columnas de tabla',
                },
                selectedRows: {
                  text: 'fila(s) seleccionadas',
                  delete: 'Eliminar',
                  deleteAria: 'Eliminar filas seleccionadas',
                },
              },
              customToolbarSelect: () => {},
              onRowsSelect: (currentRowsSelected, allRowsSelected) => {
                setSelectedContexts(
                  allRowsSelected?.map((row) => ({
                    question: contexts?.docs[row?.dataIndex]?.id,
                    questionType: 'ContextQuestions',
                  }))
                );
              },
              onTableChange: (action, tableState) => {
                switch (action) {
                  case 'changePage':
                    setPageContexts(tableState.page);
                    break;
                  case 'changeRowsPerPage':
                    setLimitContexts(tableState.rowsPerPage);
                    break;
                  default:
                    break;
                }
              },
            }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <p style={{ marginBottom: '20px', color: '#777' }}>
            Seleccione las preguntas de la actividad
          </p>
          <MUIDataTable
            title={'Preguntas'}
            data={questions?.docs || []}
            columns={questionColumns}
            options={{
              serverSide: true,
              count: questions?.totalDocs || 0,
              page: pageQuestions,
              rowsPerPage: limitQuestions,
              selectableRows: 'multiple',
              filterType: 'dropdown',
              responsive: 'scrollMaxHeight',
              search: false,
              delete: false,
              download: false,
              print: false,
              viewColumns: false,
              textLabels: {
                body: {
                  noMatch:
                    'Lo sentimos, no se encontraron registros coincidentes',
                  toolTip: 'Ordenar',
                  columnHeaderTooltip: (column) =>
                    `Ordenar por ${column.label}`,
                },
                pagination: {
                  next: 'Siguiente',
                  previous: 'Anterior',
                  rowsPerPage: 'Filas por página:',
                  displayRows: 'de',
                },
                toolbar: {
                  search: 'Buscar',
                  downloadCsv: 'Descargar CSV',
                  print: 'Imprimir',
                  viewColumns: 'Ver columnas',
                  filterTable: 'Filtrar tabla',
                },
                filter: {
                  all: 'Todos',
                  title: 'FILTROS',
                  reset: 'REINICIAR',
                },
                viewColumns: {
                  title: 'Mostrar columnas',
                  titleAria: 'Mostrar/Ocultar columnas de tabla',
                },
                selectedRows: {
                  text: 'fila(s) seleccionadas',
                  delete: 'Eliminar',
                  deleteAria: 'Eliminar filas seleccionadas',
                },
              },
              customToolbarSelect: () => {},
              onRowsSelect: (currentRowsSelected, allRowsSelected) => {
                setSelectedQuestions(
                  allRowsSelected?.map((row) => ({
                    question: questions?.docs[row?.dataIndex]?.id,
                    questionType: 'Question',
                  }))
                );
              },
              onTableChange: (action, tableState) => {
                switch (action) {
                  case 'changePage':
                    setPageQuestions(tableState.page);
                    break;
                  case 'changeRowsPerPage':
                    setLimitQuestions(tableState.rowsPerPage);
                    break;
                  default:
                    break;
                }
              },
            }}
          />
        </div>
      </div>
      {(entries?.evaluationType === 'Prueba diagnóstica' ||
        entries?.evaluationType === 'Evaluación de periodo') && (
        <TextField
          name="time"
          label="Tiempo en minutos"
          variant="outlined"
          value={entries?.time}
          onChange={handleChange}
          className={classes.input}
        />
      )}
      <Button
        variant="contained"
        color="primary"
        className={classes.input}
        style={{ background: '#2490AF', color: 'white', marginTop: '30px' }}
        onClick={handleCreate}
        disabled={
          !entries?.description ||
          !entries?.evaluationType ||
          !entries?.serie ||
          !entries?.grade ||
          !entries?.period ||
          (selectedContexts?.length === 0 && selectedQuestions?.length === 0)
        }
      >
        Crear actividad
      </Button>
    </div>
  );
}
